import { defineMessages } from 'react-intl';

export default defineMessages({
  answers: {
    id: 'simulated.questions.alternatives.answers',
    defaultMessage: 'Answers',
  },
  distractors: {
    id: 'simulated.questions.alternatives.distractors',
    defaultMessage: 'Distractors',
  },
  alternativesFeedback: {
    id: 'simulated.questions.alternatives.alternativesFeedback',
    defaultMessage: 'Alternatives Feedback',
  },
});
